import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { type HeaderAccountDropdownContent } from '@module/mdrt-org/shared/components/header/graphql/get-header-profile-dropdown-content';
import { NoPhoto } from '@shared/ui-components/svgs';
import { useFormatTranslationString } from '@shared/utils/helpers/format-translation-string';
import { type ProfileSummary } from '../../../../utils/types/profile-summary';
import { type ProfileDropdownSummaryProps } from './types';
import styles from './profile-dropdown-summary-client.module.scss';
export const ProfileDropdownSummaryClient = t0 => {
  const $ = _c(17);
  const {
    cmsContent,
    profileSummary,
    statusChipSlot
  } = t0;
  const formatTranslationString = useFormatTranslationString();
  let t1;
  if ($[0] !== profileSummary.photoUrl) {
    t1 = <div className={styles["profile-dropdown-summary-client__photo"]}>{profileSummary.photoUrl ? <Image alt="" height={112} sizes="112px" src={profileSummary.photoUrl} width={112} /> : <NoPhoto className={styles["profile-dropdown-summary-client__icon"]} data-testid="profile-dropdown-photo-placeholder" />}</div>;
    $[0] = profileSummary.photoUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== profileSummary.displayName) {
    t2 = <div className={styles["profile-dropdown-summary-client__name"]} data-testid="profile-dropdown-display-name">{profileSummary.displayName}</div>;
    $[2] = profileSummary.displayName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== cmsContent.mdrtId || $[5] !== formatTranslationString || $[6] !== profileSummary.mdrtId) {
    t3 = formatTranslationString(cmsContent.mdrtId, {
      addColon: true,
      mdrtId: profileSummary.mdrtId
    });
    $[4] = cmsContent.mdrtId;
    $[5] = formatTranslationString;
    $[6] = profileSummary.mdrtId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <div className={styles["profile-dropdown-summary-client__id"]} data-testid="profile-dropdown-mdrt-id">{t3}</div>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== statusChipSlot) {
    t5 = statusChipSlot && <div className={styles["profile-dropdown-summary-client__chip"]}>{statusChipSlot}</div>;
    $[10] = statusChipSlot;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className={styles["profile-dropdown-summary-client"]}><div className={styles["profile-dropdown-summary-client__inner"]}>{t1}{t2}{t4}{t5}</div></div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};